import * as React from 'react';
import { useState } from 'react';
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    Grid,
    Modal,
} from '@mui/material';
import ManageCredentials from '../CredentialsManager';

const ExternalApiPredefined = () => {
    const [openCredentials, setOpenCredentials] = useState(false);

    const handleOpenCredentials = () => setOpenCredentials(true);
    const handleCloseCredentials = () => setOpenCredentials(false);
    const [provider, setProvider] = React.useState('Logate — Address Verify');
    const [endpoint, setEndpoint] = React.useState('/verify/address');
    const [requestMapping, setRequestMapping] = React.useState(
        '{ line1: Customer.Address1, city: Customer.City, postal: Customer.PostalCode }'
    );
    const [responseMapping, setResponseMapping] = React.useState(
        'response.standardizedLine1 → Address1, response.postal → PostalCode, response.geo.lat → Lat'
    );

    const handleProviderChange = (event) => {
        setProvider(event.target.value);
    };
    const handleEndpointChange = (event) => {
        setEndpoint(event.target.value);
    };

    const credentialModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 24,
        p: 3,
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Paper elevation={1} sx={{ p: 4, flexGrow: 1 }}>
                <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
                    Provider and Endpoint
                </Typography>

                <Grid container spacing={4}>
                    {/* Left Column: Provider, Endpoint, Mappings */}
                    <Grid item xs={12} md={10}>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                                Provider
                            </Typography>
                            <Grid container gap={2}>
                                <Grid item md={6}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={provider}
                                        onChange={handleProviderChange}
                                    /></Grid>
                                <Grid item md={2}><Button disabled variant="outlined" fullWidth sx={{ backgroundColor: 'rgb(234, 251, 234)', borderColor: 'rgb(189, 229, 189)', color: 'rgb(45, 122, 45)' }}>
                                    Connected
                                </Button>
                                </Grid>
                                <Grid item md={3}>
                                    <Button variant="outlined" onClick={handleOpenCredentials} sx={{ ml: 2 }}>
                                        Manage Credentials
                                    </Button>
                                    <Modal
                                        open={openCredentials}
                                        onClose={handleCloseCredentials}
                                        aria-labelledby="modal-modal-title"
                                        aria-describedby="modal-modal-description"
                                    >
                                        <Box sx={credentialModalStyle}>
                                            <ManageCredentials handleClose={handleCloseCredentials} />
                                        </Box>
                                    </Modal>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={{ mb: 3 }}>
                            <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                                Endpoint
                            </Typography>
                            <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={endpoint}
                                onChange={handleEndpointChange}
                            />
                        </Box>

                        <Box sx={{ mb: 3 }}>
                            <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                                Request Mapping
                            </Typography>
                            {/* Use a TextField with multiline and readOnly for the code-like display */}
                            <TextField
                                multiline
                                fullWidth
                                value={requestMapping}
                                InputProps={{
                                    readOnly: true,
                                    sx: {
                                        bgcolor: '#e8e8e8', // Light grey background as seen in image
                                        fontFamily: 'monospace',
                                        borderRadius: 1,
                                    },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'transparent', // Remove border if it's meant to look like a code block
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'transparent',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'transparent',
                                    },
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                                Response → Attribute Mapping
                            </Typography>
                            {/* Similar TextField for response mapping, read-only */}
                            <TextField
                                multiline
                                fullWidth
                                value={responseMapping}
                                InputProps={{
                                    readOnly: true,
                                    sx: {
                                        bgcolor: '#e8e8e8',
                                        fontFamily: 'monospace',
                                        borderRadius: 1,
                                    },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'transparent',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'transparent',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'transparent',
                                    },
                                }}
                            />
                        </Box>
                    </Grid>

                    {/* Right Column: Retries and Timeout */}
                    <Grid item xs={12} md={2}>
                        <Paper variant="outlined" sx={{ p: 2, height: 'fit-content', bgcolor: '#fcfcfc' }}>
                            <Typography variant="h6" gutterBottom>
                                Retries and Timeout
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                Timeout: 3s
                            </Typography>
                            <Typography variant="body2">
                                Retries: 2 (backoff)
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    );
};

export default ExternalApiPredefined;